import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React, { cloneElement, Component, createElement, isValidElement } from 'react';
import { withDefaultComponentProps } from '../../../decorators/withDefaultComponentProps';
import capitalizeFirstLetter from '../../../utils/capitalizeFirstLetter';
import constant from '../../../utils/constant';
const COMPONENT_NAME = 'Button';
export const sizesConstants = constant({
    LARGE: 'large',
    SMALL: 'small'
});
export const labelOrientationsConstants = constant({
    BEFORE: 'before',
    AFTER: 'after'
});
class Button extends Component {
    static sizes = sizesConstants;
    static labelOrientations = labelOrientationsConstants;
    handleClick = (e)=>{
        if (!this.props.disabled && this.props.onClick) {
            this.props.onClick(e);
        }
    };
    render() {
        const { className, containerElement, label, icon, linkButton, type, children, size, labelOrientation, disabled, primary, block, secondary, link, backgroundType, ...other } = this.props;
        let labelElement;
        let iconElement;
        let childrenFragment;
        let outputElement;
        let sizeClassName;
        let disabledClassName;
        if (label) {
            labelElement = /*#__PURE__*/ React.createElement("span", {
                className: cx('Button-label')
            }, label);
        }
        if (icon) {
            iconElement = /*#__PURE__*/ React.createElement("span", {
                className: "Button-icon"
            }, icon);
        }
        if (labelOrientation === labelOrientationsConstants.BEFORE) {
            childrenFragment = /*#__PURE__*/ React.createElement(React.Fragment, null, labelElement, iconElement, children);
        } else {
            childrenFragment = /*#__PURE__*/ React.createElement(React.Fragment, null, iconElement, labelElement, children);
        }
        if (size) {
            sizeClassName = `Button--size${capitalizeFirstLetter(size)}`;
        }
        if (disabled) {
            disabledClassName = 'Button--disabled';
        }
        const buttonProps = {
            ...other,
            type,
            disabled,
            onClick: this.handleClick,
            className: cx('Button', sizeClassName, disabledClassName, {
                'Button--primary': primary,
                'Button--secondary': !primary && secondary,
                'Button--link': !primary && !secondary && link,
                'Button--block': block
            }, className)
        };
        if (linkButton && buttonProps.href) {
            outputElement = /*#__PURE__*/ createElement('a', buttonProps, childrenFragment);
        } else {
            outputElement = /*#__PURE__*/ isValidElement(containerElement) ? /*#__PURE__*/ cloneElement(containerElement, buttonProps, childrenFragment) : /*#__PURE__*/ createElement(containerElement, buttonProps, childrenFragment);
        }
        return outputElement;
    }
}
Button.propTypes = {
    /**
	 * Setup type of background.
	 */ backgroundType: PropTypes.any,
    /**
	 * Style with --block
	 */ block: PropTypes.bool,
    /**
	 * Children will be rendered within the `containerElement`.
	 */ children: PropTypes.node,
    /**
	 * Root className.
	 */ className: PropTypes.string,
    /**
	 * Element or Component used as the root tag.
	 */ containerElement: PropTypes.node,
    /**
	 * If true, the select field will be disabled.
	 */ disabled: PropTypes.bool,
    /**
	 * Icon used inside the button.
	 */ icon: PropTypes.node,
    /**
	 * Text displayed in the button.
	 */ label: PropTypes.string.isRequired,
    /**
	 * Determines if the label should placed after of before the icon.
	 */ labelOrientation: PropTypes.oneOf(labelOrientationsConstants.values()),
    /**
	 * If true, button is styled as link action.
	 */ link: PropTypes.bool,
    /**
	 * If true, the `containerElement` is ignored and the <a /> is used for root element.
	 */ linkButton: PropTypes.bool,
    /**
	 * Callback function fired when button is clicked.
	 *
	 * @param {object} event event targeting the element.
	 * @return {undefined} Nothin'
	 */ onClick: PropTypes.func,
    /**
	 * If true, button is styled as primary action. `secondary` is ignored.
	 */ primary: PropTypes.bool,
    /**
	 * If true, button is styled as secondary action.
	 */ secondary: PropTypes.bool,
    /**
	 * Determines styling of size for the button.
	 */ size: PropTypes.oneOf(sizesConstants.values()),
    /**
	 * Equivalent to HTML attribute of `<button />`.
	 */ type: PropTypes.string
};
export { Button };
export default withDefaultComponentProps(COMPONENT_NAME, {
    containerElement: 'button',
    labelOrientation: labelOrientationsConstants.AFTER,
    type: 'button'
}, Button);
